import React from 'react';
import { styled } from '@linaria/react';
import { PageWidthContainer } from '@vio/atlas/helpers/PageWidthContainer';
import { Stack } from '@vio/atlas/helpers/Stack';
import { RangeSizesType } from 'types/Sizes';
import { CarouselWidgetsProvider } from './context/CarouselWidgetsContext';
import { ExtendYourStay } from './ExtendYourStay/ExtendYourStay';
import { RecentSearchHistory } from './RecentSearchHistory';
import { SuggestedHotels } from './SuggestedHotels';
import { TopDealsForTonight } from './TopDealsForTonight';
import { YourStays } from './YourStays';
const _exp = /*#__PURE__*/() => PageWidthContainer;
const StyledPageWidthContainer = /*#__PURE__*/styled(_exp())({
  name: "StyledPageWidthContainer",
  class: "s10wrp5h",
  propsAsIs: true
});
interface Props {
  hasContext?: boolean;
  space?: RangeSizesType;
}
const SolidCarouselWidgets: React.FC<{
  space?: RangeSizesType;
}> = ({
  space = 's800'
}) => {
  return <StyledPageWidthContainer paddingDesktopXsSize="s500" paddingMobileSmSize="s400">
      <Stack space={space}>
        <YourStays />
        <ExtendYourStay />
        <SuggestedHotels />
        <RecentSearchHistory />
        <TopDealsForTonight />
      </Stack>
    </StyledPageWidthContainer>;
};
export const CarouselWidgets: React.FC<Props> = ({
  hasContext = true,
  space = 's800'
}) => {
  if (hasContext) return <CarouselWidgetsProvider>
        <SolidCarouselWidgets space={space} />
      </CarouselWidgetsProvider>;
  return <SolidCarouselWidgets space={space} />;
};

require("./CarouselWidgets.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./CarouselWidgets.tsx");